import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { rem } from 'polished';
import avatarSizes from './setting/avatarSizes';

const styles = {
  root: {
    position: 'relative',
    borderRadius: '50%',
    display: 'flex',
    flexDirection: 'row',
    width: ({ variant }: ThemeFunction) => avatarSizes[variant],
    height: ({ variant }: ThemeFunction) => avatarSizes[variant],
  },
  avatars: {
    '& > picture': {
      width: ({ variant }: ThemeFunction) =>
        rem(avatarSizes[variant], baseFontSize),
    },
    display: 'flex',
    '& > picture, & > div': {
      marginLeft: -10,
      zIndex: 0,
      width: ({ variant }: ThemeFunction) =>
        rem(avatarSizes[variant], baseFontSize),
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
};

export default styles;
